// history.scss
import { useContext, useEffect, useState } from 'react';

import { ConversationComponent } from './conversation/conversation';

import { CosmosConn } from '../../core/cosmos/api';
import { ChatUserContext } from '../../core/chatContext';

import { User } from './iHistory';
import LoadingScreen from '../history/loadingScreen/loadingScreen';
// import styles from './history.module.scss';
// import Menu from '@mui/icons-material/Menu';
// import Close from '@mui/icons-material/Close';
import toast from 'react-hot-toast';


const HistoryComponent: React.FC<User> = ({ idUser }) => {

    const currChatContext: any = useContext(ChatUserContext);
    const [loading, setLoading] = useState(true);
    const Cosmos_Connection = new CosmosConn();

    useEffect(() => {
        if ( idUser ) {
            // Get user history and to context
            Cosmos_Connection.fetchChatHistoryInit(idUser)
                .then( mongoResponse => {
                    currChatContext.setCurrHistory(mongoResponse?.conversation.reverse() ||  []);
                    setLoading(false);
                })
                .catch( mongoResponse => {
                    toast.error("Error al cargar las conversaciones...", {
                        duration: 8000,
                        style: {
                            border: '1px black',
                            background: '#CD5C5C',
                            color: 'white',
                            padding: '20px'
                        }
                    })
                    setLoading(false);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idUser])

    return(
        <>
            <ConversationComponent userConversation={currChatContext.currHistory} />
            {loading && <LoadingScreen />}
      </>    
    )
}

export { HistoryComponent}